import CheckboxGroup from './CheckboxGroup';

export interface ICheckboxGroupOption {
  value: any;
  label: string;
}

export default CheckboxGroup;
